import styled from "styled-components";
import Select from "react-select";

export const FiltersContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 24px;
  justify-content: flex-end;
  margin-top: 12px;


  p {
    margin: 0;
  }
`;

export const Input = styled.input`
    width: 200px;
`;

export const FiltersWrapper = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;
`;

export const CustomSelect= styled(Select)` 
  width: 200px;

  div {
    border-radius: 6px;  
  }
`;
